/* eslint-disable sort-keys */
import applicationTheme from "@swa-ui/application/theme";
import authenticationTheme from "@swa-ui/authentication/theme";
import { getBootstrapData } from "@swa-ui/bootstrap";
import { colors } from "@swa-ui/core/defines";
import coreTheme from "@swa-ui/core/theme";
import dotcomTheme from "@swa-ui/dotcom/theme";
import formTheme from "@swa-ui/form/theme";
import itineraryTheme from "@swa-ui/itinerary/theme";
import loyaltyTheme from "@swa-ui/loyalty/theme";
import personalInfoTheme from "@swa-ui/personal-info/theme";
import placementsTheme from "@swa-ui/placements/theme";
import { initializeColors, initializeTheme } from "@swa-ui/theme";
import vacationsTheme from "@swa-ui/vacations/theme";

import theme from "../theme";

const colorOverrides = getBootstrapData("color-overrides") ?? {};
const themeOverrides = getBootstrapData("theme-overrides") ?? {};

initializeColors({
  ...colors,
  ...colorOverrides,
});
initializeTheme({
  light: {
    ...applicationTheme.light,
    ...authenticationTheme.light,
    ...coreTheme.light,
    ...dotcomTheme.light,
    ...formTheme.light,
    ...itineraryTheme.light,
    ...loyaltyTheme.light,
    ...personalInfoTheme.light,
    ...placementsTheme.light,
    ...vacationsTheme.light,
    ...theme.light,
    ...themeOverrides.light,
  },
  dark: {
    ...applicationTheme.dark,
    ...authenticationTheme.dark,
    ...coreTheme.dark,
    ...dotcomTheme.dark,
    ...formTheme.dark,
    ...itineraryTheme.dark,
    ...loyaltyTheme.dark,
    ...personalInfoTheme.dark,
    ...placementsTheme.dark,
    ...vacationsTheme.dark,
    ...theme.dark,
    ...themeOverrides.dark,
  },
});
